<template>
    <div id="show_words" style="display: inline-block;">
        <img src="./image/endHome.jpg" alt="" class="endHome">
        <div class="consultBtn"  @click="updated">
            <span>点击立即咨询</span>
        </div>
        <div>
            <div class="EAU">
                <span>交通路面</span>
                <span class="color_">防护全科医生</span>
            </div>
            <div class="color_EAU">
                <span class="color_1A64B0">“ 8大方式全程呵护 ”</span>
            </div>
            <div class="imgShui8">
                <i class="imgShui8">
                    <div class="smallImg1">
                        <img src="./image/shui1.png" alt="">
                        <span class="imgF">水性环保 </span>
                    </div>
                    <div class="smallImg2">
                        <img src="./image/shui2.png" alt="">
                        <span class="imgF">超长保色 </span>
                    </div>
                    <div class="smallImg3">
                        <img src="./image/shui3.png" alt="">
                        <span class="imgF">快速翻新</span>
                    </div>
                    <div class="smallImg4">
                        <img src="./image/shui4.png" alt="">
                        <span class="imgF">超强耐候 </span>
                    </div>
                    <div class="smallImg5">
                        <img src="./image/shui5.png" alt="">
                        <span class="imgF">绿色安全 </span>
                    </div>
                    <div class="smallImg6">
                        <img src="./image/shui6.png" alt="">
                        <span class="imgF">防滑耐磨 </span>
                    </div>
                    <div class="smallImg7">
                        <img src="./image/shui7.png" alt="">
                        <span class="imgF">高耐侵蚀  </span>
                    </div>
                    <div class="smallImg8">
                        <img src="./image/shui8.png" alt="">
                        <span class="imgF">经久耐用  </span>
                    </div>
                </i>
            </div>
            <div class="choice">
                <i>
                    <div class="EAU">
                        <span>为什么选择</span>
                        <span class="color_">水性EAU彩色路面？</span>
                    </div>
                    <div class="keli">
                        水性EAU彩色路面采用 生态友好型环保复合树脂技术，为路面防护提供了完美的解决方案，我们始终坚持“ 聚立安全·聚乘绿愿”的理念，长期致力于“
                        让绿建更安全、让体育更环保、让交通更靓丽”的使命建设。环保，安全，耐蚀耐磨，施工便利，历久弥新，色彩亮丽，助力海绵城市建设。
                    </div>
                    <div class="omgOne">
                        <img src="./image/one1.jpg" alt="">
                        <img src="./image/one2.png" alt="">
                        <img src="./image/one3.png" alt="">
                    </div>
                </i>
            </div>
            <div>
                <div class="EAU">
                    <span class="color_">应用场景</span>
                </div>
                <div class="application_flex">
                    <div class="bargb">
                        <span class="bargb_s">慢道喷涂型靓彩路面</span><br>
                        <span class="bargb_p">应用场景：人行天桥、公司庭院、休闲会所、运动场地、广场、街心花园、景观行人步道等</span>
                        <div class="bargb_i">
                            <img src="./image/w1.jpg" alt="" >
                            <img src="./image/w2.jpg" alt="" class="bargb_g">
                        </div>
                    </div>
                    <div class="bargb" style="margin-left: 30px;">
                        <span class="bargb_s">通用型靓彩路面</span><br>
                        <span class="bargb_p">应用场景：小型机动车道、商业街、游乐场、休闲自行车道、登山绿道、广场、堤岸景观等</span>
                        <div class="bargb_i">
                            <img src="./image/w3.jpg" alt="" >
                            <img src="./image/w4.jpg" alt="" class="bargb_g">
                        </div>
                    </div>
                    <div class="bargb" style="margin-left: 30px;">
                        <span class="bargb_s">重载型靓彩路面</span><br>
                        <span class="bargb_p">应用场景：地下车库及坡道、停车场、高速服务区、高速公路口、隧道出入口、城市道路警示区等</span>
                        <div class="bargb_i">
                            <img src="./image/w5.jpg" alt="" >
                            <img src="./image/w6.jpg" alt="" class="bargb_g">
                        </div>
                    </div>
                 </div>
            </div>
            <div class="san">
                <i>
                    <div class="EAU" style="padding-top: 55px;padding-bottom: 35px;margin-top:0">
                        <span style="color:#fff">战略合作伙伴</span>
                    </div>
                    <div class="zu_i">
                        <div  class="zu_m">
                            <img src="./image/zu2.jpg" alt=""><br>
                            <span>中国交通运输部公路科学研究院</span>
                        </div>
                        <div>
                            <img src="./image/zu1.jpg" alt=""><br>
                            <span>重庆交通大学</span>
                        </div>
                        
                    </div>
                    
                </i>
            </div>
            <div class="EAU" style="margin-top:55px;">
                <span class="color_">环保便捷</span>
                <span >的特点 深受广大相关从业者的</span>
                <span class="color_">青睐</span>
                <div>
                    <img src="./image/qian.png" alt="" style="width:1200px;height:540px;margin-top:39px;">
                </div>
            </div>
            <div class="jiu">
                <i>
                    <div class="EAU U">
                        <span >苏州大乘环保新材有限</span>
                        <span class="color_">公司简介</span>
                    </div>
                    <div class="image">
                        <img src="./image/u6.png" alt="">
                        <div style="width: 685px;">
                            <span>苏州大乘环保新材有限公司，是一家依托仿生智能科技,专注绿色新材料的高科技公司。经过十数载的积累和沉淀，在绿色校园和绿色体育领域成功研发出生态友好型环保水性EAU技术替代PU/SPU技术，完美实现跑道、步道、地坪、球场、路面的解决方案，从而保障了产品的环保性和安全性。每年涂装面积近千万平方米，合作伙伴遍及全球。伴遍及全球。</span><br>
                            <span class="maTop">苏州大乘，经过十数载的积累和沉淀，在绿色校园和绿色体育领域成功研发出生态友好型环保丙烯酸水性EAU技术替代PU/SPU技术，完美实现跑道、步道、地坪、球场、路面的解决方案，从而保障了产品的环保性和安全性。</span><br>
                            <span class="maTop">同时，绿色建材领域使用陶化彩砂代替天然彩砂的专利技术 、反射隔热多彩代替花岗岩大理石的专利技术、热惰性石膏代替水泥粉刷再生的专利技术，尤其是全耐候无防护冷屋面防水技术和轻骨料空心球技术，为缓解城市热岛效应和既有建筑节能改造方案提供了技术支撑和产品保障。</span><br>
                            <span class="maTop">在绿色低碳环保事业的大千世界里，苏州大乘是世界里的一粒无名沙。沙只有适应世界的时代变迁，适应世界的潮起潮落，用内心的坚守，让世界成为属于自己的天空。</span><br>
                        </div>
                    </div>
                </i>
            </div>
            <div>
                <div class="EAU" style="margin-top:55px;">
                    <span >大乘技术研发</span>
                    <span class="color_">雄厚实力</span>
                </div>
                <div class="flex">
                    <div>
                        <span class="biaoti">至今企业获神100多项专利授权，其中发明专利15项</span>
                        <div>
                            <img src="./image/tu.jpg" alt="" style="float: left;margin-top: 12px;">
                            <div style="float: left;"  class="go_tu">
                                <p><img src="./image/go.png" alt=""><span>省级科技厅认定工程技术中心</span></P>
                                <p><img src="./image/go.png" alt=""><span>市级无毒水性EAU高环保跑道工程技术中心国家三 星级绿色建材评价标识</span></p>
                                <p><img src="./image/go.png" alt=""><span>省级研究生工作站</span></p>
                                <p><img src="./image/go.png" alt=""><span>省级高新技术企业</span></p>
                                <p><img src="./image/go.png" alt=""><span>省、市级重合同守信用企业</span></p>
                                <p><img src="./image/go.png" alt=""><span>省级民营科技企业</span></p>
                                <p><img src="./image/go.png" alt=""><span>市级名牌产品称号</span></p>
                            </div>
                        </div>
                        
                    </div>
                    <div style="margin-left: 76px;">
                        <img src="./image/der.jpg" alt="">
                    </div>
                </div>
            </div>
            <div>
                <i class="bott1">
                    <div class="dispF">
                        <div class="tuL">
                            <div class="FAWU">六大帮扶政策，为您保驾护航</div>
                            <img src="./image/bott2.png" alt="">
                            <div class="fonDiv">
                                <span>只要是<span class="color_">相关行业从业者</span>，即可加入，同时可以获得一手的扶持政策</span>
                            </div>
                            <div style="display: inline-block;width: 445px;">
                                <div class="fonDiv_size">
                                    <span>A.经销客户政策</span><br>
                                    <span> B.人员支持政策</span><br>
                                    <span> C.目标政策支持</span><br>
                                    
                                </div>
                                <div class="fonDiv_size">
                                    <span> D.上图推广支持</span><br>
                                    <span>E.区域保护支持</span><br>
                                    <span> F.施工技术支持 </span><br>
                                    <!--<span> 7.区域授权</span><br>
                                    <span> 8. 施工技术支持</span><br>-->
                                </div>
                            </div>
                            
                        </div>
                        <div class="tuL">
                            <div class="FAWU">合作加盟 在线申请 COOPERATION</div>
                            <div class="ing-roll">
                                <swiper :options="swiperOption3" ref="jxjSwpier">
                                <swiper-slide v-for="(jxjItem,i) in DataList" :key="i">
                                    <div class="roll">
                                        <span class="roll-day">{{jxjItem.ago}}</span>
                                        <span class="roll-name">{{jxjItem.Name}}</span>
                                        <span class="roll-phon">{{jxjItem.Phone}}</span>
                                        <span class="roll-my">已成功加入</span>
                                    </div> 
                                </swiper-slide>
                                </swiper>
                            </div>
                            <div style="margin-top: 30px;">
                                <div class="personal">
                                    <span>姓名<input type="text" placeholder="请输入您的姓名" v-model="youName"></span>
                                </div>
                                <div class="personal">
                                    <span>电话<input type="text" placeholder="请输入您的电话" v-model="youPhone"></span>
                                </div>
                                <div class="personal" style="text-align: left;">
                                    <span>公司类型：
                                        <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                                            <el-checkbox :label="item" v-for="item in cities" ></el-checkbox>
                                        </el-checkbox-group>
                                    </span>
                                </div>
                                <div class="personal groups" style="text-align: left;margin-top: 20px;">
                                    <span>所在区域：
                                        <el-radio-group v-model="radioList" @change="handleChecked">
                                            <el-radio :label="item" v-for="item in radio" >{{item}}</el-radio>
                                        </el-radio-group>
                                    </span>
                                </div>
                            </div>
                            <div class="ziXun" @click="setGR"><span>立即咨询</span></div>
                        </div>
                    </div>
                </i>
            </div>
            <div style="text-align: center;margin: 50px 0px 0px;background: #272525;color: #666;line-height: 32px;">
                <div class="ziBot" >苏州堆绿云科技有限公司 &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;投资有风险 选择需谨慎</div>
            </div>
        </div>
        <!--模拟对话框-->
        <div class="kefu">
            <div class="kefu_img"><img src="./image/keF.png" alt="" @click="laoKe=true"></div>
            <div v-if="laoKe" class="chat">
                <div class="chatName"><span>苏州大乘环保新材有限公司</span><img src="./image/out.png" alt="" @click="laoKe=false"></div>
                <a href="https://ada.baidu.com/imlp/?imid=fe6cf0f713d8d6e5c81ffb6fefe38706" target="_blank" >
                    <div class="chat_TX">
                        <img src="./image/TX.png" alt=""><span class="chat_TX_tit">堆绿云</span><br><span class="chat_TX_NR">您好！欢迎咨询水性EAU高环保彩色路面材料招商项目！很高兴为你服务！</span>
                        <img src="./image/TX.png" alt=""><span class="chat_TX_tit">堆绿云</span><br><span class="chat_TX_NR">请输入您的手机号（例如:王先生132********）我稍后将详细的招商资料发到您的手机上</span>
                    </div>
                    
                    <div class="chat_edit"><img src="./image/SCTP.png" alt=""><br><span>我想要咨询......</span></div>
                    <div class="go"><span>发送</span></div>
                </a>
            </div>
        </div>
        <!--弹窗-->
        <div class="popup" v-show="Tpopup">
            <div class="content">
                <div class="bi">
                    <img src="./image/BI.png" alt="" @click="Tpopup = false">
                </div>
                <div class="succeed">成功提交，等待联系</div>
                <div class="oY">
                    <img src="./image/oYes.png" alt="">
                </div>
                <div class="remind">恭喜您已提交成功！稍后会有专业人员与你联系，请注意接听电话！</div>
                <!--<div class="download">
                    <img src="./image/xiaZ.png" alt="">
                    <a href="https://www.iduilv.com/master/%E4%BA%A7%E5%93%81%E8%B5%84%E6%96%99%E5%8C%85.zip">
                        <span>点击下载产品资料包</span>
                    </a>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { activityList, activityAdd,activityTypes} from '../../api/index';
import timeago from '../../pubilc/util/timeago';
export default {
    name: 'mall',
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return{
            swiperOption3: {
                slidesPerView: 5,
                direction: 'vertical',
                autoplay: {
                    delay: 5000
                },
                loop: true,
            },
            youName:'',
            youPhone:'',
            youRegion:'',
            laoKe:true,
            DataList:[],
            Tpopup:false,
            cities:[],
            checkList:[],
            radio:[],
            radioList:[],
            CompanyType:[]
        }
    },
    methods:{
        handleChecked(value){
            this.youRegion = value
        },
        handleCheckedCitiesChange(value) {
            this.CompanyType = value
        },
        down(){
            var val='https://www.iduilv.com/master/%E4%BA%A7%E5%93%81%E8%B5%84%E6%96%99%E5%8C%85.zip'
            this.$router.push({path: val})
        },
        updated(){
            this.$nextTick(function(){
          		var div = document.getElementById('show_words');
  				document.documentElement.scrollTop = div.scrollHeight;
     		})
             
        },
        async getType(){
            let res = await activityTypes();
            if(res.Type == 'Success'){
                this.cities = res.Data.CompanyType
                this.radio = res.Data.Areas
            }
        },
        async getData(){
            var _this = this
            let res = await activityList();
            if(res.Type == 'Success'){
                this.DataList = res.Data
                this.DataList.forEach(function(item,index){
                    item.ago = timeago(new Date(item.CreatedTime))
                })
            }
        },
        async setGR(){
            if(this.youName == '' || this.youPhone == '' || this.checkList==[] || this.radioList == ''){
                this.$message({message: '错误： 姓名、电话、公司类型、地址皆不可为空', type: 'warning' });
            }else if (!/^1[345789]\d{9}$/.test(this.youPhone)) {
                this.youPhone = ''
                this.$message({message: '错误,请输入正确的手机号', type: 'warning' });
                return;
            }else{
                let res = await activityAdd({
                    Name:this.youName,
                    Phone:this.youPhone,
                    Region:this.radioList,
                    CompanyType:this.checkList.join()
                });
                if(res.Type == 'Success'){
                    this.Tpopup = true
                    this.youName = '';
                    this.youPhone = '';
                    this.radioList = '';
                    this.checkList = [];
                    this.getData();
                }else{
                    alert(res.Content)
                }
            }
            
        }
    },
    created(){
        this.getData()
        this.getType()
    },
    // watch: {
    //     laoKe(val,oldVal){
    //         if(val==false){
    //             setTimeout(()=>{
    //                 this.laoKe=true
    //             },5000)
    //         }
    //     }
    // },
}
</script>

<style>
.el-radio__input.is-checked .el-radio__inner {
    border-color: #FF8A18;
    background: #FF8A18;
}
.el-radio{
    color: #4D4D4D;
}
.el-radio__input.is-checked+.el-radio__label{
    color: #4D4D4D;
}
.el-checkbox__label{
    padding: 5px 6px;
    border: 1px solid #999999;
    border-radius: 2px;
}
.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #fff;
    background: #FE8B18;
    border-color: #FE8B18;
}
.el-checkbox{
    margin-right:20px;
}
.el-checkbox__inner{
    display:none;
}
.el-checkbox-group{
    display:inline-block;
    position: relative;
    top: -6px;
}
.biaoti{
    font-weight: bold;
    margin-left: 17px;
    padding-bottom: 19px;
    display: inline-block;
    font-size: 18px;
}
.go_tu img{
    margin-top: 4px;
}
.go_tu p{
    line-height: 24px;
    margin-top: 14px;
    margin-left: 33px;
}
.go_tu span{
    width:311px;
    display:inline-block;
    margin-left: 10px;
}
.zu_i{
    display:flex;
    text-align: center;
    margin: 0 auto;
    width: 1061px;
}
.zu_m{
    margin-right:60px;
}
.zu_i span{
    color:#fff;
    font-size:20px;
    display:inline-block;
    margin-top:20px;
}
.bargb{
    width: 380px;
    height: 440px;
    background: #FFFFFF;
    box-shadow: 0px 10px 21px 0px rgba(77, 77, 77, 0.18);
}
.bargb_s{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    padding-top: 30px;
    padding-left: 38px;
    display: inline-block;
    padding-bottom: 18px;
}
.bargb_p{
    font-size: 14px;
    font-weight: bold;
    color: #666666;
    padding: 0 30px;
    display: inline-block;
}
.bargb_i{
    padding: 38px 50px;
}
.bargb_g{
    margin-top: 20px;
}
.color_1A64B0{
    color: #1A64B0;
    font-size: 27px;
    font-weight: bold;
}
.color_EAU{
    margin-top:25px;
    text-align: center;
}
.download{
    margin-top:35px;
}
.download span{
    font-size: 16px;
    font-weight: 400;
    text-decoration: underline;
    color: #315590; 
    cursor: pointer;
    margin-left: 16px;  
}
.download img{
    width:18px;
    height:18px;
    margin-top: 3px;
}
.remind{
    font-size: 16px;
    font-weight: 400;
    color: #4D4D4D;
    margin: 0 auto;
    width: 341px;
    text-align: center;
    margin-top: 29px;
}
.oY img{
    width:64px;
    height:64px;
    margin-top:43px;    
}
.succeed{
    font-size: 20px;
    font-weight: bold;
    color: #1A1A1A;
    text-align: center;
    margin-top: 30px;    
}
.bi img{
    width:18px;
    height:18px;
    padding-right: 20px;
    padding-top: 20px;
}
.oY, .download{
    text-align: center;
}
.bi{
    text-align: right;
}
.content{
    width: 460px;
    height: 380px;
    background: #FFFFFF;
    margin: 10% auto;
}
.popup{
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.go span{
    width: 80px;
    height: 32px;
    background: #FB0D0D;
    display: inline-block;
    text-align: center;
    line-height: 33px;
    color: #fff;
}
.go{
    text-align: right;
    padding: 10px;
}
.chat_edit span{
    margin-top: 4px;
    display: inline-block;
    color:#999999;
}
.chat_edit img{
    width:20px;
    height:16px;
}
.chat_edit{
    margin-top: 0px;
    border-top: 1px solid #E0E0E0;
    padding: 10px 10px 0 10px;
}
.chat_TX_NR{
    background:#F3F3F3;
    color:#000000;
    display:inline-block;
    margin: 12px 14px;
    padding: 11px 17px;
}
.chat_TX{
    margin: 20px;
}
.chat_TX img{
    height:36px;
    width:36px;
}
.chat_TX .chat_TX_tit{
    color: #666666;
    line-height: 38px;
    padding-left: 13px;
}
.chatName span{
    line-height: 37px;
}
.chatName{
    background:#FB0D0D;
    height:40px;
    width:100%;
    color:#fff;
    text-align: center;
    border:1px solid #FB0D0D;
}
.chatName img{
    float: right;
    width: 12px;
    height: 12px;
    padding: 13px 14px 13px 0;
}
.chat{
    border:1px solid #E0E0E0;
    width:340px;
    height:470px;
    margin-top:10px;
    background:#fff;
}
.kefu{
    position: fixed;
    right: 0;
    top: 40%;
    z-index:9;
}
.kefu_img{
    text-align: right;
}
.kefu_img img{
    width:48px;
    height:48px;
}
.ziBot{
    font-size:12px;
    color:#666666;
}
.ziXun{
    margin: 0 auto;
    color: #fff;
    font-size: 16px;
    margin-top: 36px;
    width: 435px;
    cursor: pointer;
}
.ziXun span{
    width: 457px;
    height:42px;
    background:#FF8A18;
    line-height: 41px;
    display:inline-block;
}
input::-webkit-input-placeholder {
  color: #999999;
  font-size:15px;
}
.personal input{
    margin-left:30px;
    width: 370px;
    height: 36px;
    border:1px solid #E0E0E0;
    padding:0 15px;
}
.personal{
    margin: 0 auto;
    width: 480px;
    text-align: right;
    margin-top: 30px;
    color: #4D4D4D;
    font-size: 15px;
}
.roll-name{
    padding-right: 25px;
    width: 80px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    position: relative;
    top: 3px;
}
.roll-phon{
    padding-right:49px;
}
.roll-my{

}
.roll-name,.roll-phon,.roll-my{
    font-size:15px;
    color:#666;
}
.roll-day{
    color:#FF8A18;
    padding-right: 20px;
    width: 55px;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    top: 3px;
}
.ing-roll .swiper-container {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.ing-roll .swiper-wrapper {
    width: 100%;
    height: 100%;
}
.ing-roll {
    position: relative;
    width: 396px;
    height: 150px;
    padding: 15px 45px 15px 39px;
    background: #fff;
    margin: 0 auto;
    z-index:0;
}
.ing-roll .swiper-slide {
    width: 100%;
    height: 20% !important;
    display: block;
    text-align: left;
    margin: 0 auto;
    color: #252525;
}
.dispF{
    display: flex;
    margin: 0 auto;
    width: 1200px;
}
.fonDiv_size{
    width: 50%;
    font-size: 15px;
    text-align: left;
    margin-top: 10px;
    line-height: 32px;
    float: left;
}
.fonDiv{
    width: 74%;
    margin: 0 auto;
    text-align: left;
    font-size: 16px;
}
.tuL img{
    width:440px;
    height:220px;
    padding-bottom:25px;
}
.FAWU{
    font-weight: bold;
    color: #1D394D;
    font-size:22px;
    padding-bottom: 29px;
}
.tuL{
    padding-top: 52px;
    width: 50%;
    text-align: center;
}
.bott1{
    background: url('./image/bott1.png') no-repeat center center;
    display: block;
    width: 100%;
    background-size: 100% 100%;
    height:623px;
    margin-top:62px;
}
.san{
    margin-top:78px;
}
.application_ span{
    width: 180px;
    display: inline-block;
    margin-top: 21px;
    font-size: 20px;
    color: #333;
    text-align: center;  
}
.application_{
    display:flex;
    margin: 0 auto; 
    width: 880px; 
    margin-top: 49px; 
}
.application:first-child{
    padding-left:0;
}
.application{
    padding-left:157px;
}
.application_flex{
    display:flex;
    margin: 0 auto;
    width: 1200px;
    margin-top: 60px;
}
.application img{
    width:180px;
    height:180px;
}
.application span{
    width: 180px;
    display: inline-block;
    margin-top: 21px;
    font-size: 20px;
    color: #333;
    text-align: center;
}
.suZ{
    color: #1a1a1a;
    font-size: 16px;
    margin: 0 auto;
    width: 1200px;
    margin-top: 35px;
}
.certificate:first-child{
    padding-left:0px;
}
.certificate span{
    width: 111px;
    display: inline-block;
    margin-top: 14px;
    font-size:14px;
    color:#333;
}
.certificate{
    width:160px;
    text-align: center;
    padding-left:48px;
}
.flex{
    display:flex;
    margin: 0 auto;
    width: 1200px;
    margin-top: 58px;
}
.certificate img{
    width:160px;
    height:200px;
    
}
.maTop{
    margin-top: 23px;
    display: inline-block;
}
.image span{
    color:#083D4F;
    font-size:15px;
}
.image{
    display: flex;
    margin: 0 auto;
    width: 1196px;
    margin-top: 50px;
}
.image img{
    width:455px;
    height:360px;
    padding-right: 47px;
}
.U{
    margin-top:0;
    padding-top:70px;
}
.jiu i{
    background: url('./image/ju.png') no-repeat center center;
    display: block;
    width: 100%;
    background-size: 100% 100%;
    height:570px;
    margin-top:60px;
}
.mod-wrap .posR{
    background: url('./image/jia.png') no-repeat center center;
    position: relative;
    margin: 0 auto;
    width:1203px;
    height:357px;
}
.thirteen5{
    position: absolute;
    top: 240px;
    right: 222px;
    width: 211px;
}
.thirteen4{
    position: absolute;
    top: 241px;
    left: 409px;
    width: 211px;
}
.thirteen3{
    position: absolute;
    top: 236px;
    left: 47px;
    width: 211px;
    color: #fff;
}
.thirteen2{
    position: absolute;
    top: 55px;
    right: 47px;
    width: 211px;   
}
.thirteen1{
    position: absolute;
    top: 20px;
    left: 586px;
    width: 211px;
}
.thirteen{
    position: absolute;
    top: 28px;
    left: 229px;
    width: 211px;
}
.thirteenY{
    font-size: 18px;
    font-weight:bold;
}
.thirteenD{
    font-size: 15px;
    margin-top: 5px;
    display: inline-block;
}
.san i{
    background: url('./image/jia1.jpg') no-repeat center center;
    display: block;
    width: 100%;
    /*background-size: 100%;*/
    height:348px;
    
}
.left{
    float:left;

}
.keli{
    margin: 0 auto;
    width: 53%;
    text-align: center;
    margin-top: 25px;
    font-size: 15px;
    line-height: 27px;
}
.omgOne img:first-child{
    padding-left: 0px;
}
.omgOne img{
    padding-left: 42px;
    width:30%;
}
.omgOne{
    margin: 0 auto;
    width: 61.3%;
    margin-top: 35px;
}
.choice .EAU{
    margin-top:0;
    padding-top:52px; 
}
.choice{
    margin-top:63px;
}
.choice i{
    background: url('./image/one.jpg') no-repeat center center;
    display: block;
    width: 100%;
    height: 660px;
    background-size: 100% 100%;
    position: relative;
      
}
.smallImg8 img{
    width:27px;
    height:27px;
    margin-top: -2px;
}
.smallImg8{
    position: absolute;
    top: 395px;
    right: 115px;
}
.smallImg7 img{
    width:30px;
    height:26px;
    margin-top: -2px;
}
.smallImg7{
    position: absolute;
    top: 348px;
    left: 106px;
}
.smallImg6 img{
    width:24px;
    height:28px;
    margin-top: -3px;
}
.smallImg6{
    position: absolute;
    top: 272px;
    right: 94px;
}
.smallImg5 img{
    width:27px;
    height:27px;
    margin-top: -3px;
}
.smallImg5{
    position: absolute;
    top: 234px;
    left: 88px;
}
.smallImg4 img{
    width:27px;
    height:27px;
    margin-top: -2px;
}
.smallImg4{
    position: absolute;
    top: 138px;
    right: 93px;
}
.smallImg3 img{
    width:26px;
    height:26px;
    margin-top: -3px;
}
.smallImg3{
    position: absolute;
    top: 122px;
    left: 127px;
}
.smallImg2{
    position: absolute;
    top: 18px;
    right:118px;
}
.smallImg2 img{
    width:27px;
    height:27px;
    margin-top: -3px;
}
.imgF{
    font-size:15px;
    color:#333;
    margin-left: 10px;
}
.smallImg1{
    position: absolute;
    left: 104px;
    top: 18px;
}
.smallImg1 img{
    width:21px;
    height:28px;
    margin-top: -4px;
}
.imgShui8{  
    margin: 0 auto;
}
.color_{
    color:#095FD5;
}
.EAU{
    text-align: center;
    margin-top:60px;
    font-size:32px;
    font-weight: bold;
}
.imgShui8 i{
    background: url('./image/shui.png') no-repeat center center;
    display: block;
    width: 1113px;
    height: 460px;
    background-size: 100%;  
    margin-top: 30px;
    position: relative;
}
.consultBtn span{
    background: #FF8A18;
    -webkit-box-shadow: 0px 5px 6px 0px #E17705;
    box-shadow: 0px 5px 6px 0px #E17705;
    border-radius: 30px;
    padding: 12px 112px;
    font-size: 20px;
    color: #fff;
    margin-top: 30px;
    display: inline-block;
    width: 350px;
}
.consultBtn{
    text-align: center;
}
.endHome{
    width: 100%;
    height: auto;
}
.top-tab-box.fixation{
    display:none;
}
.m-footer-links{
    display:none;
}
</style>
